import MCalendarRangeField from './index.vue';

MCalendarRangeField.install = app => {
  app.component(MCalendarRangeField.name, MCalendarRangeField);
};

export default MCalendarRangeField;
